// extracted by mini-css-extract-plugin
export default {"flex":"flexBox_flex__1ZJNQ","flexGeo":"flexBox_flexGeo__HWjVI"};